export default __webpack_public_path__ + "static/11-a04d73947b15bc4fcf8250d17f2bf17a.jpg";